(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDialogController', PhoneCallPurposeDialogController);

    PhoneCallPurposeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallPurpose) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallPurpose.id !== null) {
                PhoneCallPurpose.update(vm.phoneCallPurpose, onSaveSuccess, onSaveError);
            } else {
                PhoneCallPurpose.save(vm.phoneCallPurpose, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallPurposeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
